import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IBooking } from 'app/shared/model/booking.model';
import { getEntities as getBookings } from 'app/entities/booking/booking.reducer';
import { IBookingPament } from 'app/shared/model/booking-pament.model';
import { getEntity, updateEntity, createEntity, reset } from './booking-pament.reducer';

export const BookingPamentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const bookings = useAppSelector(state => state.booking.entities);
  const bookingPamentEntity = useAppSelector(state => state.bookingPament.entity);
  const loading = useAppSelector(state => state.bookingPament.loading);
  const updating = useAppSelector(state => state.bookingPament.updating);
  const updateSuccess = useAppSelector(state => state.bookingPament.updateSuccess);

  const handleClose = () => {
    navigate('/booking-pament' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getBookings({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...bookingPamentEntity,
      ...values,
      booking: bookings.find(it => it.id.toString() === values.booking.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...bookingPamentEntity,
          booking: bookingPamentEntity?.booking?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="activitiesApp.bookingPament.home.createOrEditLabel" data-cy="BookingPamentCreateUpdateHeading">
            <Translate contentKey="activitiesApp.bookingPament.home.createOrEditLabel">Create or edit a BookingPament</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="booking-pament-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('activitiesApp.bookingPament.totalPaid')}
                id="booking-pament-totalPaid"
                name="totalPaid"
                data-cy="totalPaid"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.bookingPament.totalDiscount')}
                id="booking-pament-totalDiscount"
                name="totalDiscount"
                data-cy="totalDiscount"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.bookingPament.paymentDate')}
                id="booking-pament-paymentDate"
                name="paymentDate"
                data-cy="paymentDate"
                type="date"
              />
              <ValidatedField
                label={translate('activitiesApp.bookingPament.paymentMethod')}
                id="booking-pament-paymentMethod"
                name="paymentMethod"
                data-cy="paymentMethod"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.bookingPament.userEmail')}
                id="booking-pament-userEmail"
                name="userEmail"
                data-cy="userEmail"
                type="text"
              />
              <ValidatedField
                id="booking-pament-booking"
                name="booking"
                data-cy="booking"
                label={translate('activitiesApp.bookingPament.booking')}
                type="select"
              >
                <option value="" key="0" />
                {bookings
                  ? bookings.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/booking-pament" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BookingPamentUpdate;
